var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 213.121,
    height: 73.62,
    viewBox: "0 0 213.121 73.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG_12",
    "data-name": "SVG 12",
    transform: "translate(-36.2 -32.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M127.34,72.24h-8.62l-3.43-8.57-2.95-7.43-4.98-12.4-4.57,11.38-3.36,8.45L96,72.24H87.59l16.07-38.5h7.61Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M166.22,65.28a22.952,22.952,0,0,1-5.25,4.37,19.484,19.484,0,0,1-10.13,2.46c-.15,0-.3-.01-.44-.01-.32-.01-.64-.02-.95-.05a18.779,18.779,0,0,1-13.59-7.06,19.756,19.756,0,0,1-2.16-3.42,20.478,20.478,0,0,1-2.08-8.54c-.01-.2-.01-.39-.01-.59v-.11a19.768,19.768,0,0,1,7.21-15.56c.13-.1.26-.21.39-.31.2-.15.4-.3.61-.44a19.594,19.594,0,0,1,11.35-3.46,25.523,25.523,0,0,1,4.47.38,18.518,18.518,0,0,1,10.31,5.52l-5.25,6.17a14.607,14.607,0,0,0-7.78-4.17,11.983,11.983,0,0,0-1.82-.14,10.513,10.513,0,0,0-2.12.21,10.247,10.247,0,0,0-1.09.28,10.859,10.859,0,0,0-6.61,6.17,12.98,12.98,0,0,0-1,4.01c-.04.4-.06.81-.06,1.22v.11a13.135,13.135,0,0,0,2.05,7.18c.2.31.41.6.64.89a10.965,10.965,0,0,0,1.42,1.47,10.235,10.235,0,0,0,6.77,2.48c4.29,0,6.91-1.75,9.86-4.48Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M205.16,65.28a22.952,22.952,0,0,1-5.25,4.37,19.484,19.484,0,0,1-10.13,2.46c-.15,0-.3-.01-.44-.01-.32-.01-.64-.02-.95-.05a18.779,18.779,0,0,1-13.59-7.06,19.756,19.756,0,0,1-2.16-3.42,20.478,20.478,0,0,1-2.08-8.54c-.01-.2-.01-.39-.01-.59v-.11a19.768,19.768,0,0,1,7.21-15.56c.13-.1.26-.21.39-.31.2-.15.4-.3.61-.44a19.594,19.594,0,0,1,11.35-3.46,25.641,25.641,0,0,1,4.48.38,18.518,18.518,0,0,1,10.31,5.52l-5.25,6.17a14.607,14.607,0,0,0-7.78-4.17,11.983,11.983,0,0,0-1.82-.14,10.513,10.513,0,0,0-2.12.21,10.247,10.247,0,0,0-1.09.28,10.859,10.859,0,0,0-6.61,6.17,12.98,12.98,0,0,0-1,4.01c-.03.4-.06.81-.06,1.22v.11a13.219,13.219,0,0,0,2.05,7.18c.2.31.42.6.64.89a11.619,11.619,0,0,0,1.42,1.47,10.235,10.235,0,0,0,6.77,2.48c4.29,0,6.91-1.75,9.86-4.48Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M70.76,52.88v.11a19.025,19.025,0,0,1-3.73,11.53,18.377,18.377,0,0,1-6.31,5.3,21.557,21.557,0,0,1-9.89,2.29H36.2l8.25-7.59h6.38c5.12,0,8.97-2.67,10.54-6.91a12.953,12.953,0,0,0,.77-4.5V53a14.667,14.667,0,0,0-.11-1.78,12.45,12.45,0,0,0-.76-3c-1.63-4.12-5.42-6.74-10.43-6.74H44.46l-8.25-7.59H50.84a21.967,21.967,0,0,1,8.64,1.69,18.337,18.337,0,0,1,7.61,5.9,18.492,18.492,0,0,1,3.55,9.11C70.71,51.33,70.76,52.1,70.76,52.88Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 8.25,
    height: 38.23,
    transform: "translate(75.01 33.87)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M210.33,58.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M249.11,49.01A19.2,19.2,0,0,0,239.1,34.69a20.07,20.07,0,0,0-4.1-1.6,21.275,21.275,0,0,0-5.56-.73,20.59,20.59,0,0,0-9.57,2.3,19.269,19.269,0,0,0-9.09,10.24,20.138,20.138,0,0,0-1.33,7.23v.11a20.6,20.6,0,0,0,.86,5.91,19.184,19.184,0,0,0,5.01,8.25,19.865,19.865,0,0,0,14.01,5.5A20.331,20.331,0,0,0,240,68.98a19.311,19.311,0,0,0,8.11-9.91,20.232,20.232,0,0,0,1.13-5.13c.05-.6.08-1.2.08-1.82v-.11A18.754,18.754,0,0,0,249.11,49.01ZM238.32,59.75c-.13.17-.27.35-.4.51a10.816,10.816,0,0,1-8.46,3.89,10.99,10.99,0,0,1-7.35-2.74,11.867,11.867,0,0,1-3.43-5.4c-.01-.03-.02-.06-.03-.1a13.038,13.038,0,0,1-.55-3.78v-.11a12.651,12.651,0,0,1,2.11-7.12c.18-.26.36-.51.56-.76a10.715,10.715,0,0,1,3.93-3.05,11.171,11.171,0,0,1,4.64-.98,11,11,0,0,1,6.34,1.95,11.671,11.671,0,0,1,4.37,5.96,12.943,12.943,0,0,1,.65,4.1v.11a12.605,12.605,0,0,1-2.13,7.14A3.564,3.564,0,0,1,238.32,59.75Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M52.47,105.07a32.157,32.157,0,0,1-7.18.9c-.82,0-1.6-.04-2.33-.11a14.089,14.089,0,0,1-2.36-.45,8.557,8.557,0,0,1-2.18-.9,4.515,4.515,0,0,1-1.52-1.55,4.311,4.311,0,0,1-.6-2.28V91.45a4.719,4.719,0,0,1,.89-2.9,5.037,5.037,0,0,1,2.39-1.73,15.468,15.468,0,0,1,2.85-.75,18.54,18.54,0,0,1,2.85-.21,44.392,44.392,0,0,1,6.73.48v2.25a27.5,27.5,0,0,0-3.28-.5c-1.42-.15-2.55-.23-3.4-.23q-6.165,0-6.16,3.55v9.2a2.586,2.586,0,0,0,.59,1.7,3.474,3.474,0,0,0,1.59,1.05,10.555,10.555,0,0,0,1.98.48,15.5,15.5,0,0,0,2.12.14,18.8,18.8,0,0,0,4.3-.54V96.62H45.2V94.58h7.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M70.8,105.37H67.22l-5.59-8.32H58.81v8.32H55.9V85.87h6.85a13.552,13.552,0,0,1,5.26.74c1.06.49,1.59,1.52,1.59,3.08v3.37a3,3,0,0,1-1.47,2.72,6.639,6.639,0,0,1-3.58.92ZM66.68,92.69v-2.7c0-1.46-1.26-2.19-3.79-2.19H58.8v7.33h3.82a7.062,7.062,0,0,0,3.07-.51A1.982,1.982,0,0,0,66.68,92.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M90.19,91.43v9.26a4.644,4.644,0,0,1-.77,2.7,4.5,4.5,0,0,1-2.09,1.64,12.511,12.511,0,0,1-2.61.74,17.39,17.39,0,0,1-2.79.21q-8.175,0-8.17-5.29V91.46q0-5.6,8.17-5.59Q90.195,85.87,90.19,91.43Zm-2.82,9.22V91.36c0-2.4-1.8-3.61-5.41-3.61a13.194,13.194,0,0,0-2.01.14,6.269,6.269,0,0,0-1.68.51,2.838,2.838,0,0,0-1.26,1.11,3.5,3.5,0,0,0-.45,1.85v9.29c0,2.24,1.81,3.37,5.44,3.37C85.58,104.02,87.37,102.89,87.37,100.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M108.91,85.87v14.51q0,5.295-7.63,5.29a17.11,17.11,0,0,1-2.73-.2,9.493,9.493,0,0,1-2.37-.72,3.988,3.988,0,0,1-1.83-1.64,5.257,5.257,0,0,1-.66-2.73V85.87h2.79v14.48a2.755,2.755,0,0,0,1.29,2.64,7.393,7.393,0,0,0,3.58.72,7.127,7.127,0,0,0,3.53-.72,2.788,2.788,0,0,0,1.25-2.64V85.87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M127.44,89.71v4.06a3.679,3.679,0,0,1-1.94,3.53,11.807,11.807,0,0,1-5.48,1.04h-2.91v7.03H114.2V85.87h6.37q1.2,0,2.07.06a11.952,11.952,0,0,1,1.85.29,4.528,4.528,0,0,1,1.56.63,3.328,3.328,0,0,1,.99,1.13A3.432,3.432,0,0,1,127.44,89.71Zm-2.85,3.91V90.07a2.084,2.084,0,0,0-.42-1.34,2.226,2.226,0,0,0-1.2-.74,7.874,7.874,0,0,0-1.31-.26c-.35-.03-.79-.05-1.31-.05h-3.28v8.8h3.34a6.254,6.254,0,0,0,2.96-.65A2.254,2.254,0,0,0,124.59,93.62Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.659663e2e1692965fb7e9b60ac9d7e23.svg";
export { ForwardRef as ReactComponent };